// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Brand`
};

const el_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Μάρκα`
};

const ru_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Бренд`
};

const he_brand = /** @type {(inputs: {}) => string} */ () => {
	return `מותג`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const brand = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.brand(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("brand", locale)
	if (locale === "en") return en_brand(inputs)
	if (locale === "el") return el_brand(inputs)
	if (locale === "ru") return ru_brand(inputs)
	if (locale === "he") return he_brand(inputs)
	return "brand"
};